import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateOrderChangeOtherPriceRationaleGql } from '../../WorkOrderChangeQueries';

export const useUpdateOrderChangeOtherPriceRationale = () => {
    const dispatch = useDispatch();

    const [resetUpdateData] = useResetStoreData({ requestId: 'uerUpdateOrderChangeOtherPriceRationale' });

    const [
        uerUpdateOrderChangeOtherPriceRationaleData,
        uerUpdateOrderChangeOtherPriceRationaleStatus,
        ,
        updateOrderChangeOtherPriceRationale,
    ] = useRequest({
        requestId: 'uerUpdateOrderChangeOtherPriceRationale',
        query: uerUpdateOrderChangeOtherPriceRationaleGql,
        withEffect: false,
    });

    const updateOrderChangeOtherPriceRationaleHandler = useCallback(
        (rationale: string, workOrderChangeOtherPriceId: number, workOrderOtherPriceId: number) => {
            dispatch(
                updateOrderChangeOtherPriceRationale({
                    workOrderChangeOtherPriceId,
                    workOrderOtherPriceId,
                    input: {
                        rationale,
                    },
                }),
            );
        },
        [updateOrderChangeOtherPriceRationale, dispatch],
    );

    useEffect(
        () => () => {
            resetUpdateData(undefined);
        },
        [resetUpdateData],
    );

    return useMemo(
        () => ({
            uerUpdateOrderChangeOtherPriceRationaleStatus,
            updateOrderChangeOtherPriceRationaleHandler,
            uerUpdateOrderChangeOtherPriceRationaleData,
        }),
        [
            updateOrderChangeOtherPriceRationaleHandler,
            uerUpdateOrderChangeOtherPriceRationaleStatus,
            uerUpdateOrderChangeOtherPriceRationaleData,
        ],
    );
};
